import { ComponentConfig } from "@measured/puck"
import { MediaSelect } from "../../../../../media/pages/SelectMediaUIBuilder"
import { MediaItems, RenderCustomMedia } from "./RenderConfig"

export const CCACustomMedia: ComponentConfig<MediaItems> = {
  label: "CaoCao | Custom Media",
  fields: {
    item: {
      label: "Items",
      type: "array",

      arrayFields: {
        country: {
          label: "Country",
          type: "text",
        },

        city: {
          label: "City",
          type: "text",
        },

        coverImage: {
          label: "Cover Image",
          type: "custom",
          render: props => <MediaSelect {...props} />,
        },

        previewImage: {
          label: "Preview Image",
          type: "array",

          arrayFields: {
            previewImage: {
              label: "Preview Image",
              type: "custom",
              render: props => <MediaSelect {...props} />,
            },
          },
        },
      },

      getItemSummary: (name, index) =>
        `${index ? index + 1 : 1}. ${name.country ?? "item"}  ${name.city && `- ${name.city}`}`,
      ...RenderCustomMedia,
    },
  },
  defaultProps: {
    item: [
      {
        country: "Vietnam",
        city: "Hanoi",
      },
      {
        country: "Thailand",
        city: "Bangkok",
      },
      {
        country: "Japan",
        city: "Tokyo",
      },
    ],
  },
  ...RenderCustomMedia,
}
